const COPYRIGHT_START_YEAR = 2026;
const COPYRIGHT_HOLDER = "jtarchive";

export function copyrightNotice(year = new Date().getFullYear()): string {
  const years =
    year <= COPYRIGHT_START_YEAR ? `${COPYRIGHT_START_YEAR}` : `${COPYRIGHT_START_YEAR}–${year}`;
  return `© ${years} ${COPYRIGHT_HOLDER}`;
}
